/*
* custom.js by Wolfgang Teufl | teuflswerk.at
*/

const $ = require('jquery');
window.$ = window.$ || $
window.jQuery = window.jQuery || $
var $window = $(window);
var winWidth = $window.width()
const Swiper = require('swiper/swiper-bundle.min.js');
const Shuffle = require('shufflejs/dist/shuffle.min.js');

var scrollTop = $window.scrollTop();

$(document).ready(function ($) {

	$('#butMobileNav').on('click', function(){
		var $nav = $('header nav');
		var $butMobileNavClose = $('#butMobileNavClose');
		if ($nav.css('display')==='none') {
			$nav.css('display','block');
			$('html').css('overflow-y','hidden');
			$(this).hide();
			$butMobileNavClose.show();
		} else {
			$nav.hide();
			$(this).show();
			$butMobileNavClose.hide();
			$('html').css('overflow-y','auto');
		}
	});
	$('#butMobileNavClose').on('click', function(){
		var $nav = $('header nav');
		if ($nav.css('display')==='block') {
			$nav.hide();
			$(this).hide();
			$('#butMobileNav').show();
			$('html').css('overflow-y','auto');
		} else {
			$nav.css('display','block');
			$(this).show();
			$('html').css('overflow-y','hidden');
			$('#butMobileNavClose').show();
		}
	});
	$('#topNav').find('a').each(function() {
		$(this).on('click', function(){
			$('#topNav li').removeClass('active');
			$(this).parent().addClass('active');
			var $butMobileNavClose = $('#butMobileNavClose');
			if ($butMobileNavClose.css('display')!=='none') {
				$butMobileNavClose.click();
			}
		});
	});

	// init news categories and preset 'any'
	var $shuffleContainer = $('#categoriesDataList');
	if ($shuffleContainer.length > 0) {
		var selector = $shuffleContainer.data('selector');

		window.shuffleInstance = new Shuffle($shuffleContainer[0], {
			itemSelector: selector,
			// custom init-cat by an id-selector, default is any
			group: $('#shuffleInitGroup').data('cat') || 'any'
		});

		$('#categories button').on('click',function () {
			// remove active class
			$('#categories button').removeClass('active');

			var $catButton = $(this);
			$catButton.addClass('active');
			var cat = $catButton.data('cat');
			if (!window.shuffleInstance) {
				$('#categoriesDataList ' + selector).show();
				window.shuffleInstance = new Shuffle($('#categoriesDataList')[0], {
					itemSelector: selector,
					group: cat
				});
			} else {
				window.shuffleInstance.filter(cat);
			}
		});
	}



	// // handle form button
	// var $btnContactForm = $('#btnContact');
	// if ($btnContactForm.length) {
	// 	$btnContactForm.click(function() {
	// 		custom.submitForm($btnContactForm.data('frm'),false);
	// 	});
	// }

	// custom.initHeroSwiper();
	custom.initGlossar();
	custom.createMainNavSubs();
	custom.handleCookiePolicyBar();
	custom.initMemberGalleries();
	// custom.initTeamSwiper();
});

$window.resize(function() {
	custom.createMainNavSubs();
	custom.handleCookiePolicyBar(true);
	if (winWidth !== $window.width()) {
		if ($('#mobileNav').css('display')==='block') {
			$('header nav').hide();
			$('#butMobileNavClose').hide();
			$('#butMobileNav').show();
		} else {
			if ($window.width()>=1200) {
				$('header nav').css('display','inline-flex');
			}
		}
	}
});

$window.scroll(function() {

	var curScrollTop = $window.scrollTop();

	var parallaxImg = $('.hero-parallax .img');
	if (parallaxImg.length) {
		var pos = parseInt(parallaxImg.css('background-position-y'));
		if (curScrollTop > scrollTop) {
			pos++;
			if (pos>100) pos=100;
		} else {
			pos--;
			if (pos<0) pos=0;
		}
		parallaxImg.css('background-position','50% '+ pos + '%');
	}
	scrollTop = curScrollTop;

	var $factCounter = $('.fact-counter');
	if ($factCounter.length) {
		$factCounter.find('.fact-counter-entry .counter').each(function(index) {
			if (!$(this).data('initialized')) {
				if (scrollTop >= $factCounter.scrollTop()) {
					$(this).data('initialized',true)
					custom.initFactCounter($(this),index)
				}
			}
		});
	}

	// if (scrollTop > 70) {
	// 	$('header').addClass('scrolling')
	// } else {
	// 	$('header').removeClass('scrolling')
	// }
});
// web-object
var custom = window.custom = {

	initGlossar: function() {
		$('.glossar').each(function() {
			var $ba = $(this);
			var $entries = $ba.find('.entry');
			$entries.each(function(index) {
				var $entry = $(this);
				$entry.find('.wrap').on('click',function() {
					if ($entry.hasClass('opened')) {
						$entry.removeClass('opened');
					} else {
						$entry.addClass('opened');
					}
				});
			});
		});

		// scoll to anchor if given
		var param = custom.getUrlParam('t');
		if (param) {
			$('html,body').animate({scrollTop: $('div.entry.' + param).offset().top -150}, 500);
		}
	},

	getUrlParam: function(param) {
		var entries = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			entries.push(hash[0]);
			entries[hash[0]] = hash[1];
		}
		return entries[param] || false;
	},

	filterMemberList: function() {
		$('#membersList .member-teaser').css('display','inline-block');
		var searchTerm = $('#memberSearchTerm').val();
		searchTerm = ((searchTerm || '').toLowerCase()).trim();
		if (searchTerm !== '') {
			var hits = 0;
			$('#membersList').find('.member-teaser').each(function() {
				var $t = $(this);
				// var hasHits = false;
				var searchBase = ($t.find('h3 a').text() + ' ' + $t.find('h4').text() || '').toLowerCase().trim();
				if (searchBase.indexOf(searchTerm)>=0) {
					// hasHits = true;
					$t.css('display','inline-block');
					hits++;
				} else {
					$t.hide();
				}
			})
		}
	},

	filterJobList: function(abortSearch,hideMsgBox) {

		var $searchTermField = $('#jobSearchTerm');
		var searchTerm = $searchTermField.val();
		searchTerm = ((searchTerm || '').toLowerCase()).trim();
		var $msgBox 	= $('#msgBox');
		if (hideMsgBox === true) $msgBox.hide();

		if (abortSearch === true || searchTerm === '') {
			$searchTermField.val('');
			// remove filter and init cats (custom init-cat by an id-selector, default is any)
			window.shuffleInstance.filter($('#shuffleInitGroup').data('cat') || 'any');
			$('#categories').show();
			if (searchTerm === '') $msgBox.hide();
		} else {
			if (searchTerm !== '') {
				var matches = [];
				$('#categoriesDataList').find('.job-teaser').each(function() {
					var $t = $(this);
					var searchBase = ($t.find('h3 a').text() + ' ' + $t.find('h4').text() || '').toLowerCase().trim();
					if (searchBase.indexOf(searchTerm)>=0) {
						matches.push($t.data('hit'))
					}
				})
				if (matches.length) {
					$('#categories').hide();
					window.shuffleInstance.filter(matches);
					custom.showMsg($msgBox, 'Die Einschränkung nach <strong>"' + searchTerm + '"</strong> lieferte <strong>' + (matches.length) + '</strong> Treffer!', true);
				} else {
					custom.showMsg($msgBox, 'Die Einschränkung nach "' + searchTerm + '" lieferte keine Treffer!', false);
					window.shuffleInstance.filter(['none']);

				}
			}
		}
	},

	ddHandler: false,
	ddActive: false,

	createMainNavSubs: function () {
		var $topNav = $('#topNav');
		$('#topNav li').each(function() {
			var $li = $(this);
			var $subNav = $li.find('div.s');
			if ($subNav.length) {
				var ddID = $subNav.data('id');
				$li.hover(
					function () {
						if ($window.width()>=1470) {
							if (custom.ddActive!== ddID) {
								window.clearTimeout(custom.ddHandler[ddID]);
								$('div.s[data-id='+custom.ddActive+']').hide();
								custom.ddActive = ddID;
								var navMaxRight = Math.round($topNav.position().left || 0) + ($topNav.width() || 0);
								custom.ddHandler[ddID] = window.setTimeout(function () {
									$li.addClass('sub_active');
									if (navMaxRight < Math.round($subNav.parent().position().left || 0) + ($subNav.width() || 0)) {
										$subNav.css('left',navMaxRight-$subNav.width());
									}
									// $subNav.slideDown(100);
									$subNav.show();
								}, 100);
							}
						}
					}, function () {
						if ($window.width()>=1470) {
							window.clearTimeout(custom.ddHandler[ddID]);
							custom.ddHandler[ddID] = window.setTimeout(function () {
								// $subNav.slideUp(100);
								$subNav.hide();
								$li.removeClass('sub_active');
								custom.ddActive = false;
							}, 200);
						}
					}
				);
			}
		})
	},

	factCounterIntervals: {},
	initFactCounter : function($counter, index) {
		var final= $counter.data('final') * 1;
		if (final > 0) {
			var step= ($counter.data('step') * 1);
			if (!(step > 0)) step = (final / 10);
			var val = 0;
			custom.factCounterIntervals[index] = setInterval(function() {
				val += step;
				if (val>final) {
					val = final;
					clearInterval(custom.factCounterIntervals[index]);
				} else {
					val = Math.ceil(val);
				}
				$counter.html(val.toLocaleString('de-DE'))
			}, 75);
		}
	},

	initMemberGalleries: function () {
		$('.gallery-list .gallery').each(function() {
			var $gallery = $(this);
			$gallery.on('click',function () {
				custom.showMemberGallery($gallery)
			})
		})
	},

	openLightBox: function(items, options) {
		var pswpElement = document.getElementById('pswp');
		var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
	},

	showMemberGallery: function($gallery) {
		var pswpElement = document.getElementById('pswp');
		var galleryData = $gallery.data('gallery');
		if (!galleryData) return;
		var entries = galleryData.split('||');
		var items = [];
		for (var i=0;i<entries.length;i++) {
			var img = entries[i].split('##');
			if (img.length === 3) {
				items.push({
					w: 		img[0],
					h:		img[1],
					src:	img[2]
				});
			}
		}
		custom.openLightBox(
			items,
			{ index: 0 }
		);
	},

	validateEmail : function(email) {
		var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
		return re.test(email);
	},

	initTeamSwiper: function() {
		var $swiper = $('.block-team.swiper');
		if ($swiper.data('slide-count') > 1) {
			var sc = {
				slidesPerView: 6,
				spaceBetween: 30,
				preloadImages: false,
				loop: true,
				lazy: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				}
			};
			new Swiper($swiper[0], sc);
		}
	},

	// addShariff: function() {
	// 	new Shariff($('#shariff'), {
	// 		orientation: 'horizontal',
	// 		buttonStyle: 'icon',
	// 		services: ['facebook', 'linkedin'],
	// 		lang: 'de'
	// 	});
	// },

	handleCookiePolicyBar: function(resizeCall) {

		if (typeof resizeCall === "undefined") resizeCall = false;
		var cookieName = "NECESSARY_COOKIES_ACCEPTED";
		// cookie-policy-bar must be displayed
		if (document.cookie.indexOf(cookieName)===-1) {
			var $cookiePolicyBar = $('.cookie-policy-bar');
			//show bar and
			$cookiePolicyBar.show();
			// handle button action
			if (!resizeCall) {
				$cookiePolicyBar.find('button').on('click',function(){
					// set cookie to remember
					var d = new Date();
					d.setTime(d.getTime() + (31*24*60*60*1000));
					document.cookie = cookieName + "=true;expires=" + d.toUTCString() + ";path=/";
					// remove cookie-bar
					$(this).parent().hide();
				});
			}
		}
	},

	filterCategoriesList: function(abortSearch) {

		//if (typeof abortSearch === 'undefined') abortSearch = false;
		var $frm = $('#searchForm');
		var $searchTermField = $frm.find('input[name=searchTerm]');
		var searchTarget = $frm.find('input[name=searchTarget]').val() || 'news';
		var $msgBox 	= $('#msgBox');
		// hide message-box
		$msgBox.hide();

		if (abortSearch === true) {
			// empty the search field
			$searchTermField.val('');
			// remove filter and init cats (custom init-cat by an id-selector, default is any)
			window.shuffleInstance.filter($('#shuffleInitGroup').data('cat') || 'any');
			// show categories
			$('#categories').show();
			// done
			return;
		}

		// get search-term
		var searchTerm = $.trim($searchTermField.val());

		// search-term must not be empty
		if (searchTerm === '') {
			custom.showMsg($msgBox, 'Bitte geben Sie einen Suchbegriff ein!', false);
			return;
		}

		if (searchTarget !== 'news' && searchTarget !== 'member' && searchTarget !== 'job' ) {
			custom.showMsg($msgBox, 'Ungültiger Aufruf!', false);
			return;
		}

		// call filter script
		$.ajax({
			url: 	'/search',
			method: 'post',
			data: 	$frm.serialize(),
			cache:	false,
			async: 	true
		})
		.done(function(result)
		{
			// no matches
			if (!result.success) {
				custom.showMsg($msgBox, 'Der Suchbegriff "' + searchTerm + '" lieferte keine Treffer!', false);
			} else {
				custom.showMsg($msgBox, 'Der Suchbegriff <strong>"' + searchTerm + '"</strong> lieferte <strong>' + (result.matches.length) + '</strong> Treffer!', true);
			}

			// hide categories
			$('#categories').hide();

			// apply matches in result as filter
			window.shuffleInstance.filter(result.matches);

		})
		.fail(function(err) {
			custom.showMsg($msgBox, 'Beim Filtern der Liste ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.', false);
		});
	},

	showMsg: function($el, msg, success) {
		$el.addClass('alert-' + (success ? 'success' : 'danger')).removeClass('alert-' + (success ? 'danger' : 'success')).show().find('p').html(msg);
		$el.find('button').addClass('btn-' + (success ? 'success' : 'danger')).removeClass('btn-' + (success ? 'danger' : 'success'));
	},
};